export default __webpack_public_path__ + "static/media/internet-380x380.11bce5be.png";